var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('h1',{staticClass:"is-size-5 has-margin-bottom-small"},[_vm._v("Biological attributes")]),_c('div',{staticClass:"is-padded-small"},[_c('key-value-table',{attrs:{"items":_vm.tableItems}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }